<template>
    <div class="wrapper">
        <NavBar />
        <!-- Spinner Start -->
        <div id="spinner" v-if="halamanloading"
            class="show bg-white position-fixed translate-middle w-100 vh-100 top-50 start-50 d-flex align-items-center justify-content-center"
            style="opacity: 0.5;">
            <div class="spinner-border text-danger" style="width: 3rem; height: 3rem;" role="status">
                <span class="sr-only">Loading...</span>
            </div>
        </div>
        <!-- Spinner End -->
        <div class="container-fluid py-2" style="background-color: white !important;">
            <div class="content-header">
                <div class="container-fluid">
                    <div class="row mb-2">
                        <div class="col-sm-12 text-center wow fadeInDown">
                            <img :src="folder" alt="User Profil" class="img-size-50 mr-3 img-circle shake-element"
                                style="height: 80px !important;width: 80px !important;"><br><br>
                            <h5>Halo {{ sapaan }}, <span class="text-success">{{ namauser }}</span>, {{
                                jabatanuser }}
                            </h5>
                            <div class="row">
                                <div class="col-sm-2 text-center"></div>
                                <div class="col-sm-8 text-center">
                                    <div class="card" style="background-color: rgba(255, 255, 255, 0.1)">
                                        <div class="row py-2 px-2">
                                            <div class="col-sm-12 text-center" style="padding-bottom: 5px;">
                                                {{ hasil }} {{ hariAngka }}
                                            </div>
                                            <div class="col-sm-12 text-center" style="padding-bottom: 5px;">
                                                <div class="row py-2 px-2">
                                                    <div class="col-sm-12 text-center bgbiru">
                                                        <h2 class="text-white">Statistik Absensi</h2>
                                                    </div>
                                                    <div class="col-sm-12 text-center">&nbsp;</div>
                                                    <div class="col-sm-4 text-center">
                                                        <label>Bulan<small class="text-info"> (*wajib
                                                                dipilih)</small></label>
                                                        <v-select :options="bulan" :reduce="(label) => label.code"
                                                            label="label" v-model="defaultSelectedbulan"
                                                            @update:modelValue="onbulanChange"
                                                            style="background-color: #ffffff;padding-bottom: 10px;"></v-select>
                                                    </div>
                                                    <div class="col-sm-4 text-center">
                                                        <label>Tahun<small class="text-info"> (*wajib
                                                                dipilih)</small></label>
                                                        <v-select :options="tahun" :reduce="(label) => label.code"
                                                            label="label" v-model="defaultSelectedtahun"
                                                            @update:modelValue="ontahunChange"
                                                            style="background-color: #ffffff;padding-bottom: 10px;"></v-select>
                                                    </div>
                                                    <div class="col-sm-4 text-center">
                                                        <label>Opsi</label><br>
                                                        <button type="button"
                                                            class="btn btn-primary btn-sm text-white lebar2"
                                                            @click="prosesdata()" data-toggle="tooltip"
                                                            data-placement="left" title="Lihat data..">
                                                            <i class="far fa-chart-bar"></i> Lihat Statistik
                                                        </button>
                                                    </div>
                                                    <div class="col-sm-12 text-left">
                                                        <div class="col-sm-12 text-center">
                                                            <label class="text-success">Statistik Absensi</label>
                                                        </div>
                                                        <div class="row">
                                                            <div class="direct-chat-msg">
                                                                <img class="direct-chat-img" :src="gambarpu"
                                                                    alt="message user image">
                                                                <div class="direct-chat-text">
                                                                    Target Total Hari Kerja Bulan {{ texthasilabsen }}:
                                                                    <span class="birumuda">
                                                                        {{ G_numFormat(jumlah_hari_kerja) }} Hari
                                                                    </span>
                                                                </div>
                                                            </div>
                                                            <div class="direct-chat-msg right">
                                                                <img class="direct-chat-img" :src="folder"
                                                                    alt="message user image">
                                                                <div class="direct-chat-text">
                                                                    Jumlah Hari Kerja Personil Sampai {{ hasilabsen }}:
                                                                    <span class="birumuda">
                                                                        {{ G_numFormat(jumlah_hari_masuk_kerja) }} Hari
                                                                    </span>
                                                                    <div class="progress">
                                                                        <div class="progress-bar"
                                                                            :style="'width:' + persentase_hari_kerja + '%'">
                                                                            {{ G_numFormatKoma(persentase_hari_kerja) }}
                                                                            %
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div class="direct-chat-msg">
                                                                <img class="direct-chat-img" :src="gambarpu"
                                                                    alt="message user image">
                                                                <div class="direct-chat-text">
                                                                    Target Total Jam Kerja Bulan {{ texthasilabsen }}:
                                                                    <span class="birumuda">
                                                                        {{ G_numFormatKoma(jumlah_jam_hari_kerja) }} Jam
                                                                    </span>
                                                                </div>
                                                            </div>
                                                            <div class="direct-chat-msg right">
                                                                <img class="direct-chat-img" :src="folder"
                                                                    alt="message user image">
                                                                <div class="direct-chat-text">
                                                                    Jumlah Jam Kerja Personil Bulan {{ texthasilabsen
                                                                    }}:
                                                                    <span class="birumuda">
                                                                        {{ G_numFormatKoma(jumlah_jam_masuk_kerja) }}
                                                                        Jam
                                                                    </span>
                                                                    <div class="progress">
                                                                        <div class="progress-bar"
                                                                            :style="'width:' + persentase_jam_kerja + '%'">
                                                                            {{ G_numFormatKoma(persentase_jam_kerja) }}
                                                                            %
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div class="direct-chat-msg">
                                                                <img class="direct-chat-img" :src="gambarpu"
                                                                    alt="message user image">
                                                                <div class="direct-chat-text">
                                                                    Target Total Jam Kerja Sampai {{ hasilabsen }}:
                                                                    <span class="birumuda">
                                                                        {{ G_numFormatKoma(jumlah_jam_kerja) }} Jam
                                                                    </span>
                                                                </div>
                                                            </div>
                                                            <div class="direct-chat-msg right">
                                                                <img class="direct-chat-img" :src="folder"
                                                                    alt="message user image">
                                                                <div class="direct-chat-text">
                                                                    Jumlah Jam Kerja Personil Sampai {{ hasilabsen }}:
                                                                    <span class="birumuda">
                                                                        {{ G_numFormatKoma(jumlah_jam_masuk_kerja) }}
                                                                        Jam
                                                                    </span>
                                                                    <div class="progress">
                                                                        <div class="progress-bar"
                                                                            :style="'width:' + persentase_jam_kerja_sekarang + '%'">
                                                                            {{
                                                                                G_numFormatKoma(persentase_jam_kerja_sekarang)
                                                                            }}
                                                                            %
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="col-sm-12 text-left">&nbsp;</div>
                                                    <div class="col-sm-12 text-left">
                                                        <div class="col-sm-12 text-center">
                                                            <label class="text-success">Sakit, Izin, Cuti & Perjalanan
                                                                Dinas</label>
                                                        </div>
                                                        <div class="row">
                                                            <div class="col-sm-12 text-center">
                                                                <h1>
                                                                    <span class="birumuda" style="font-size: 100px;">
                                                                        {{
                                                                            G_numFormat(jumlah_hari_sakit + jumlah_hari_izin
                                                                                + jumlah_hari_cuti + jumlah_hari_dl)
                                                                        }}
                                                                    </span>
                                                                    Hari
                                                                </h1>
                                                            </div>
                                                            <div class="direct-chat-msg right">
                                                                <img class="direct-chat-img" :src="folder"
                                                                    alt="message user image">
                                                                <div class="direct-chat-text">
                                                                    Jumlah Hari Izin Sakit Sampai {{ hasilabsen }}:
                                                                    <span class="birumuda">
                                                                        {{ G_numFormat(jumlah_hari_sakit) }} Hari
                                                                    </span>
                                                                </div>
                                                            </div>
                                                            <div class="direct-chat-msg right">
                                                                <img class="direct-chat-img" :src="folder"
                                                                    alt="message user image">
                                                                <div class="direct-chat-text">
                                                                    Jumlah Hari Izin Keperluan Sampai {{ hasilabsen }}:
                                                                    <span class="birumuda">
                                                                        {{ G_numFormat(jumlah_hari_izin) }} Hari
                                                                    </span>
                                                                </div>
                                                            </div>
                                                            <div class="direct-chat-msg right">
                                                                <img class="direct-chat-img" :src="folder"
                                                                    alt="message user image">
                                                                <div class="direct-chat-text">
                                                                    Jumlah Hari Izin Cuti Sampai {{ hasilabsen }}:
                                                                    <span class="birumuda">
                                                                        {{ G_numFormat(jumlah_hari_cuti) }} Hari
                                                                    </span>
                                                                </div>
                                                            </div>
                                                            <div class="direct-chat-msg right">
                                                                <img class="direct-chat-img" :src="folder"
                                                                    alt="message user image">
                                                                <div class="direct-chat-text">
                                                                    Jumlah Hari Perjalanan Dinas Sampai Sampai {{
                                                                        hasilabsen
                                                                    }}:
                                                                    <span class="birumuda">
                                                                        {{ G_numFormat(jumlah_hari_dl) }} Hari
                                                                    </span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="col-sm-12 text-center">&nbsp;</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-2 text-center"></div>
                            </div>
                        </div><!-- /.col -->
                        <div class="col-sm-12 text-center">&nbsp;</div>
                        <div class="col-sm-12 text-center">&nbsp;</div>
                    </div><!-- /.row -->
                </div><!-- /.container-fluid -->
            </div>
            <!-- /.content-header -->
        </div>
        <Footer />
    </div>
</template>

<script>
import $ from 'jquery';
import axios from 'axios';
import vSelect from 'vue-select';
import Footer from "../componen/FooterAksi.vue";
import NavBar from "../componen/NavBarAksi.vue";
import Menu from "../componen/Menu.vue";
import swal from 'sweetalert2';
import VueApexCharts from "vue3-apexcharts";
import { quillEditor } from 'vue3-quill';
window.Apex.chart = { fontFamily: "Poppins-SemiBold, Arial, sans-serif" };

export default {
    components: {
        Footer, NavBar, Menu, vSelect, apexchart: VueApexCharts, quillEditor, swal,
    },
    data() {
        return {
            halamanloading: true,
            showFilter: true,
            iduser: JSON.parse(localStorage.getItem("isistemaksi")),
            leveluser: JSON.parse(localStorage.getItem("lsistemaksi")),
            namauser: JSON.parse(localStorage.getItem("namasistemaksi")),
            jabatanuser: JSON.parse(localStorage.getItem("jabatansistemaksi")),
            tokensistemaksi: JSON.parse(localStorage.getItem("tokensistemaksi")),
            jam_bebas: JSON.parse(localStorage.getItem("jam_bebasaksi")),
            datapesan: '',
            sapaan: '',
            datamaster: [],
            carikata: '',
            datatahun: [],
            tahun: [],
            defaultSelectedtahun: {
                code: 0,
                label: 'Pilih Tahun',
                tag: '',
            },
            selectedtahun: '',
            tahunsekarang: new Date().getFullYear(),
            jam: '',
            menit: '',
            detik: '',
            hasil: '',
            texthasil: '',
            hasilabsen: '',
            texthasilabsen: '',
            hariAngka: '',
            statusjam: '',
            timer: null,
            folder: process.env.VUE_APP_URL_API + 'androidAbsensi-Gambar?f=' + JSON.parse(localStorage.getItem("ikonsistemaksi")),
            gambarpu: '../img/logojateng.png',
            latitude: '',
            longitude: '',
            project_id: process.env.VUE_APP_PROJECT_ID,
            jam_masuk: '',
            jam_pulang: '',
            tanggal_masuk: '',
            tanggal_pulang: '',
            tipe: '',
            id: '',
            ket: '',
            class: '',
            proses: '',
            durasi: '',
            jamdurasi: 0,
            menitdurasi: 0,
            detikdurasi: 0,
            linknya: process.env.VUE_APP_URL_API,
            dari_tanggal: '',
            sampai_tanggal: '',
            bulan: [],
            databulan: [],
            defaultSelectedbulan: {
                code: 0,
                label: 'Pilih Bulan',
                tag: '',
            },
            selectedbulan: '',
            bulansekarang: new Date().getMonth(),
            keterangan: '',
            validasi: false,
            jumlah_hari_kerja: 0,
            jumlah_hari_masuk_kerja: 0,
            jumlah_jam_hari_kerja: 0,
            jumlah_jam_masuk_kerja: 0,
            jumlah_jam_kerja: 0,
            jumlah_hari_sakit: 0,
            jumlah_hari_izin: 0,
            jumlah_hari_cuti: 0,
            jumlah_hari_dl: 0,
            persentase_hari_kerja: 0,
            persentase_jam_kerja: 0,
            persentase_jam_kerja_sekarang: 0,
        }
    },
    methods: {
        validasidata() {
            if ((this.selectedbulan == '') || (this.selectedbulan === null) || (this.selectedbulan === undefined)) {
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: 'Pilih Bulan..',
                });
                return false;
            }
            if ((this.selectedtahun == '') || (this.selectedtahun === null) || (this.selectedtahun === undefined)) {
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: 'Pilih Tahun..',
                });
                return false;
            }
            this.validasi = true;
            return;
        },
        prosesdata() {
            this.validasidata();
            if (this.validasi == false) {
                return false;
            }
            this.halamanloading = true;
            var datatanggal = '';
            var tanggal = '01';
            var bulan = this.selectedbulan;
            bulan = (bulan < 10) ? "0" + bulan : bulan;
            var tahun = this.selectedtahun;

            datatanggal = tahun + '-' + bulan + '-' + tanggal;

            var fd = new FormData();
            fd.append("id_user", this.iduser);
            fd.append("datatanggal", datatanggal);
            fd.append("jam_bebas", this.jam_bebas);
            fd.append("project_id", this.project_id);

            const mainAPI = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    "Content-Type": "form-data",
                    Authorization: "Bearer " + localStorage.getItem("tokensistemaksi"),
                },
            });
            mainAPI.post("StatistikAbsensi-Data", fd).then(
                Response => {
                    this.jumlah_hari_kerja = 0;
                    this.jumlah_hari_masuk_kerja = 0;
                    this.jumlah_jam_hari_kerja = 0;
                    this.jumlah_jam_masuk_kerja = 0;
                    this.jumlah_jam_kerja = 0;
                    this.jumlah_hari_sakit = 0;
                    this.jumlah_hari_izin = 0;
                    this.jumlah_hari_cuti = 0;
                    this.jumlah_hari_dl = 0;
                    this.persentase_hari_kerja = 0;
                    this.persentase_jam_kerja = 0;
                    this.persentase_jam_kerja_sekarang = 0;
                    this.datapesan = Response.data.message;
                    if (this.datapesan == 'data diketemukan') {
                        this.jumlah_hari_kerja = Response.data.content.data[0].jumlah_hari_kerja;
                        this.jumlah_hari_masuk_kerja = Response.data.content.data[0].jumlah_hari_masuk_kerja;
                        this.jumlah_jam_hari_kerja = Response.data.content.data[0].jumlah_jam_hari_kerja;
                        this.jumlah_jam_masuk_kerja = Response.data.content.data[0].jumlah_jam_masuk_kerja;
                        this.jumlah_jam_kerja = Response.data.content.data[0].jumlah_jam_kerja;
                        this.jumlah_hari_sakit = Response.data.content.data[0].jumlah_hari_sakit;
                        this.jumlah_hari_izin = Response.data.content.data[0].jumlah_hari_izin;
                        this.jumlah_hari_cuti = Response.data.content.data[0].jumlah_hari_cuti;
                        this.jumlah_hari_dl = Response.data.content.data[0].jumlah_hari_dl;
                        this.persentase_hari_kerja = Response.data.content.data[0].persentase_hari_kerja;
                        this.persentase_jam_kerja = Response.data.content.data[0].persentase_jam_kerja;
                        this.persentase_jam_kerja_sekarang = Response.data.content.data[0].persentase_jam_kerja_sekarang;
                        this.hasilabsen = Response.data.content.data[0].hariakhir;
                        this.texthasilabsen = Response.data.content.data[0].bulan;
                        this.halamanloading = false;
                    }
                    else {
                        this.halamanloading = false;
                    }
                }
            ).catch(function (error) {
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: error
                });
            }
            )
        },
        LihatWaktu() {
            this.timer = setInterval(() => {
                var jam = new Date().getHours();
                if (jam < 12) {
                    this.sapaan = "Selamat Pagi";
                } else if (jam < 15) {
                    this.sapaan = "Selamat Siang";
                } else if (jam < 19) {
                    this.sapaan = "Selamat Sore";
                } else {
                    this.sapaan = "Selamat Malam";
                }

                var now = new Date();

                this.jam = now.getHours();
                this.menit = now.getMinutes();
                this.detik = now.getSeconds();
                this.jam = (this.jam < 10) ? "0" + this.jam : this.jam;
                this.menit = (this.menit < 10) ? "0" + this.menit : this.menit;
                this.detik = (this.detik < 10) ? "0" + this.detik : this.detik;

                this.hariAngka = 'Jam: ' + this.jam + ':' + this.menit + ':' + this.detik; // 0 (Minggu) - 6 (Sabtu) [10]
                //this.durasi = this.jamdurasi + ':' + this.menitdurasi + ':' + this.detikdurasi; // 0 (Minggu) - 6 (Sabtu) [10]
                var tanggal = now.getDate(); // 1 - 31 [2]
                var bulan = now.getMonth(); // 0 - 11 [2]
                var tahun = now.getFullYear(); // 4 digit tahun [2]

                // Array nama hari dan bulan (opsional, untuk hasil dalam Bahasa Indonesia)
                var namaHari = ["Minggu", "Senin", "Selasa", "Rabu", "Kamis", "Jumat", "Sabtu"];
                var namaBulan = ["Januari", "Februari", "Maret", "April", "Mei", "Juni", "Juli", "Agustus", "September", "Oktober", "November", "Desember"];

                // Format: "Selasa, 3 Februari 2026"
                this.hasil = namaHari[now.getDay()] + ", " + tanggal + " " + namaBulan[bulan] + " " + tahun;
                this.texthasil = namaBulan[bulan] + " " + tahun;

                if ((this.bulansekarang + 1 == this.selectedbulan) && (this.selectedtahun == this.tahunsekarang)) {
                    this.hasilabsen = this.hasil;
                    this.texthasilabsen = this.texthasil;
                }

            }, 1000);
        },
        async ambilmaster() {
            this.halamanloading = true;

            const mainAPI5 = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("tokensistemaksi"),
                },
            });
            var random = Math.random();
            await mainAPI5.get("Master-Bulan?random=" + random + "&project_id=" + this.project_id).then(
                Response => {
                    this.datapesan = Response.data.message;
                    //alert(this.datapesan);
                    if (this.datapesan == 'data diketemukan') {
                        this.databulan = [];
                        this.bulan = [];
                        this.databulan = Response.data.content.data;
                        this.databulan.forEach((item) => {
                            this.bulan.push({
                                label: item.nama,
                                code: this.databulan.indexOf(item) + 1,
                                tag: item.id,
                            });
                            if ((this.bulansekarang + 1) == item.id) {
                                this.selectedbulan = item.id;
                                this.defaultSelectedbulan = {
                                    code: this.databulan.indexOf(item) + 1,
                                    label: item.nama,
                                    tag: item.id,
                                };
                            }
                        });
                        this.bulan.unshift({
                            label: 'Pilih Bulan',
                            code: 0,
                            tag: '',
                        });
                    }
                    this.halamanloading = false;
                }
            ).catch(error => {
                console.log(error);
                //this.ClearlocalStorage();
                this.halamanloading = false;
            })

            var random = Math.random();
            await mainAPI5.get("Master-Tahun?random=" + random + "&project_id=" + this.project_id).then(
                Response => {
                    this.datapesan = Response.data.message;
                    //alert(this.datapesan);
                    if (this.datapesan == 'data diketemukan') {
                        this.datatahun = [];
                        this.tahun = [];
                        this.datatahun = Response.data.content.data;
                        this.datatahun.forEach((item) => {
                            this.tahun.push({
                                label: item.nama,
                                code: this.datatahun.indexOf(item) + 1,
                                tag: item.id,
                            });
                            if ((this.tahunsekarang) == item.id) {
                                this.selectedtahun = item.id;
                                this.defaultSelectedtahun = {
                                    code: this.datatahun.indexOf(item) + 1,
                                    label: item.nama,
                                    tag: item.id,
                                };
                            }
                        });
                        this.tahun.unshift({
                            label: 'Pilih Tahun',
                            code: 0,
                            tag: '',
                        });
                    }
                    this.halamanloading = false;
                }
            ).catch(error => {
                console.log(error);
                //this.ClearlocalStorage();
                this.halamanloading = false;
            })

            this.prosesdata();
        },
        onbulanChange(a) {
            try {
                this.selectedbulan = this.bulan[a].tag;
                this.prosesdata();
            }
            catch (err) {
                return;
            }
        },
        ontahunChange(a) {
            try {
                this.selectedtahun = this.tahun[a].tag;
                this.prosesdata();
            }
            catch (err) {
                return;
            }
        },
        keluar() {
            swal.fire({
                title: "Konfirmasi",
                text: "Yakin Hendak Keluar Aplikasi?",
                icon: "warning",
                showCancelButton: true,
                cancelButtonText: "Batal",
                confirmButtonColor: "#3a4767",
                cancelButtonColor: "#ffaa05",
                confirmButtonText: "Keluar"
            }).then((result) => {
                if (result.isConfirmed) {
                    this.ClearlocalStorageAksi();
                }
            });

            return false;
        },
    },
    mounted() {
        this.ambilmaster();
        this.LihatWaktu();
        //this.halamanloading = false;
    }
}
</script>
<style></style>